module.exports = __webpack_public_path__ + "img/bni.4bd464fe.png";